export default __webpack_public_path__ + "static/media/ey_logo.c6c097bd.png";